module.exports = __webpack_public_path__ + "img/PayID_logo.1237e496.svg";